import * as R from 'remeda'

import { type Brand } from '~/hooks/useSurveyQuery'
import {
  mapNineSegment,
  type NineSegment,
  type NineSegmentCounts,
} from '~/utils'

import {
  calcNineSegmentIndicatorCounts,
  type NineSegmentIndicator,
} from './nineSegments'

export type NineSegmentsTotalData = {
  counts: Record<NineSegment | NineSegmentIndicator | 'total', number>
  ratios: Record<NineSegment | NineSegmentIndicator | 'total', number>
}

export type NineSegmentsTotalDataInput = {
  brand: Brand
  // Resolved by hook from useGetBrandNineSegmentIndex. basic-output supplies a
  // function consistent with its own reshape rather than reading Jotai state.
  getBrandNineSegmentIndex: (brand: Brand, nineSegment: NineSegment) => number
  // tabulationQueryData?.question?.groupCounts ?? []
  groupCounts: ReadonlyArray<number>
  // useSampleSize() value. Same denominator the existing page uses.
  sampleSize: number
}

export const buildNineSegmentsTotalData = (
  input: NineSegmentsTotalDataInput,
): NineSegmentsTotalData => {
  const total = input.sampleSize
  const nineSegmentCounts: NineSegmentCounts = mapNineSegment((nineSegment) => {
    const index = input.getBrandNineSegmentIndex(input.brand, nineSegment)

    return input.groupCounts[index] ?? NaN
  })
  const counts = {
    total,
    ...nineSegmentCounts,
    ...calcNineSegmentIndicatorCounts(nineSegmentCounts),
  }

  const ratios = R.mapValues(counts, (count) => count / counts.total)

  return { counts, ratios }
}
